export default {
  event: {
    header: {
      events: "Zuletzt empfangene Geräte-Meldungen",
    },
    noEvents: "Keine Meldungen vorhanden",
    loadError:
      "Fehler beim laden der Events. Bitte versuchen Sie es später nochmals oder kontaktieren Sie unseren Support.",
  },
  auth: {
    signInPageTitle: "Melden Sie sich bei Ihrem Konto an",
    form: {
      username: "E-Mail",
      password: "Passwort",
    },
    action: {
      signIn: "Einloggen",
    },
  },
  login: {
    welcomeBack: "Willkommen zurück",
    signInToAccount: "Melden Sie sich bei Ihrem CARU-Konto an",
    emailAddress: "E-Mail-Adresse",
    enterEmail: "Geben Sie Ihre E-Mail ein",
    sendVerificationCode: "Passcode senden",
    sendingCode: "Code wird gesendet...",
    checkYourEmail: "Überprüfen Sie Ihre E-Mail",
    sentCodeTo: "Wir haben einen Passcode gesendet an",
    checkSpamFolder: "Bitte überprüfen Sie Ihren Spam-Ordner, falls Sie die E-Mail nicht sehen.",
    verificationCode: "Passcode",
    enterCode: "6-stelligen Code eingeben",
    verifyAndSignIn: "Verifizieren & Anmelden",
    verifying: "Wird verifiziert...",
    resendCode: "Code erneut senden",
    resending: "Wird gesendet...",
    codeResent: "Code wurde gesendet",
    codeResentMessage: "Ein neuer Passcode wurde an Ihre E-Mail gesendet",
    useDifferentEmail: "← Andere E-Mail verwenden",
    allRightsReserved: "Alle Rechte vorbehalten",
    loginWithPassword: "Mit Passwort anmelden",
    loginWithCode: "Mit Passcode anmelden",
    password: "Passwort",
    enterPassword: "Geben Sie Ihr Passwort ein",
    signIn: "Anmelden",
    signingIn: "Anmelden...",
    forgotPassword: "Passwort vergessen?",
    resetPasswordDescription:
      "Geben Sie Ihre E-Mail-Adresse ein, um einen Code zum Zurücksetzen Ihres Passworts zu erhalten.",
    resetPassword: "Passwort zurücksetzen",
    sendResetCode: "Code senden",
    newPassword: "Neues Passwort",
    enterNewPassword: "Geben Sie Ihr neues Passwort ein",
    passwordResetSuccess: "Ihr Passwort wurde erfolgreich zurückgesetzt",
    backToLogin: "Zurück zum Login",
    errors: {
      sendingCode: "Beim Senden des Codes ist ein Fehler aufgetreten.",
      invalidCode: "Ungültiger Code oder es ist ein Fehler aufgetreten.",
      signInNotCompleted: "Anmeldung nicht abgeschlossen. Bitte versuchen Sie es erneut.",
      unexpectedStep: "Unerwarteter nächster Schritt",
      noEmailAttribute: "Es wurde kein Benutzer mit dieser Email Adresse gefunden. Bitte kontaktieren Sie den Support.",
      userNotFound: "Kein Konto mit dieser E-Mail-Adresse gefunden",
      userDisabled: "Dieses Konto wurde deaktiviert",
      userNotConfirmed: "Bitte verifizieren Sie zuerst Ihre E-Mail",
      tooManyAttempts: "Zu viele Fehlversuche. Bitte versuchen Sie es später erneut",
      accountLocked: "Konto vorübergehend gesperrt aufgrund zu vieler Fehlversuche",
      otpExpired: "Passcode abgelaufen. Bitte fordern Sie einen neuen an",
      sessionInvalid: "Ihre Sitzung ist abgelaufen. Bitte starten Sie neu",
      networkError: "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung",
      generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut",
    },
  },
  notifications: {
    mutations: {
      success: "Änderungen gespeichert!",
      error: "Fehler aufgetreten",
      delivering: "Das Gerät erhält die Änderungen in Kürze.",
      contactSupport: "Bitte kontaktieren Sie den CARU-Support",
      jsonParse: "Server konnte Ihr JSON nicht parsen. Bitte kontrollieren Sie die Daten.",
      templateStored: "Konfigurationsvorlage wurde erfolgreich gespeichert.",
      templateStoredFailure:
        "Ein Fehler ist aufgetreten. Bitte versuchen Sie es nochmals oder kontaktieren Sie den Support.",
      userInvited: "Benutzer wurde erfolgreich eingeladen!",
      userInvitedDescription: "Benutzer wurde eingeladen und die E-Mail mit dem temporären Passwort versendet.",
      userInvitedError:
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals oder kontaktieren Sie den Support.",
      userUpdates: "Benutzer wurde erfolgreich geändert!",
      deleteUser: "Benutzer wurde erfolgreich gelöscht!",
      rebootSuccess: "Gerät wird neu gestartet",
      deviceRebootTriggered: "{ serialNumber } wird neu gestartet. Das kann einige Minuten dauern.",
      deviceRebootFailed: "Ein Fehler ist aufgetreten beim neu starten des Gerätes: { serialNumber } ",
    },

    auth: {
      error: "Ein Fehler ist aufgetreten",
      invalidCredentials: "Benutzername oder Passwort falsch.",
    },
  },
  device: {
    label: "Gerät | Geräte",
    selectionSingular: "{ selection } Gerät ausgewählt",
    selection: "{ selection } Geräte ausgewählt",
    listPageTitle: "Nutzerverwaltung",
    detailsPageTitle: "Nutzerkonto",
    softwareSupport:
      "Ihr Gerät ist mit einer veralteten Softwareversion ausgestattet. Bitte schalten Sie das Gerät ein, sodass die neueste Software automatisch installiert werden kann. Sobald das Update durchgeführt wurde kann das Gerät in der Plattform wie gewohnt konfiguriert werden. Für weitere Fragen wenden Sie sich gerne an unseren Support:",
    header: {
      deviceConnectivityStatus: "Geräteverbindungsstatus",
      connectivityStatus: "Verbindungsstatus",
      serialNumber: "Seriennummer",
      id: "Geräte ID",
      tenant: "Kundengruppe",
      firmware: "Firmware",
      version: "Version",
      notifications: "Benachrichtigungen",
      copyConfiguration: "Einstellungen kopieren",
      setGroup: "Zugehörigkeit Kundengruppe einrichten",
      tabNotification: "Benachrichtigung bei Stromausfall",
      unknown: "Unbekannt",
      bracelets: "Funksender Seriennummer konfigurieren",
      braceletColumn: "Funksender IDs",
      arcConfig: "Notrufzentrale",
      setOwner: "Gerät einer Kundengruppe zuweisen",
      dailyCheck: "Tagestaste",
      co2Toggle: "CO2-Ampel",
      hydrationReminder: "Trinkerinnerung",
      wifiConnection: "Wifi Verbindung (Optional)",
      changeTenant: "Kundengruppe wechseln",
      changeTenantDescription: "Wählen Sie eine neue Kundengruppe für das Gerät aus.",
      changeTenantsDescription: "Wählen Sie eine neue Kundengruppe für die Geräte aus.",
      changeTenantLabel: "Kundengruppe wählen:",
      sureTenantChange: "Wollen Sie die Kundengruppe wirklich ändern?",
    },
    co2Settings: {
      dayNightMode: "Tag-Nachtmodus aktivieren",
      intervalSelection: "Zeitfenster einstellen",
      intervalDescriptionOff: "Die Lichter des Geräts sind von { start } Uhr bis { end } Uhr ausgeschaltet.",
      intervalDescriptionDimmed: "Das Gerät wird von { start } Uhr bis { end } Uhr in den gedimmten Modus versetzt.",
      nightMode: "LED Licht",
      nightModeActive: "Nachtmodus aktiv",
      nightModeInactive: "Nachtmodus inaktiv",
      nightModes: {
        active: "Aktiv",
        dimmed: "Gedimmt",
        off: "Aus",
      },
    },
    form: {
      permissions: "Zugriffsrechte",
      roles: {
        none: "Kein Zugriff",
        viewer: "Nur Ansicht",
        admin: "Admin",
      },
      notifications: "Benachrichtigungen",
      alarmDestinations: "Notruf Kontakte / Alarmzentralen",
      bracelets: "Funksender",
      sourceDevice: "Source Device",
      ownerName: "Kundengruppe",
      selectDevice: "- Gerät auswählen -",
      msisdn: "Telefonnummer der SIM-Karte",
      nomsisdn: "Keine Telefonnummer der SIM-Karte hinterlegt",
      permissionTenant: "Sie haben keine ADMIN-Rechte für diese Kundengruppe.",
    },
    action: {
      diagnose: "Diagnose",
      group: "Gerätegruppe",
      owner: "Kundengruppe wechseln",
      alarmConfig: "Notruf Konfiguration",
      notifications: "Benachrichtigungen",
      reset: "Gerät zurücksetzen",
      reboot: "Gerät neu starten",
      shutdown: "Gerät herunterfahren",
      deactivate: "Gerät deaktivieren",
      selfDiagnosis: "Selbsttest",
      copyConfig: "Einstellungen kopieren",
      changeOwner: "Kundengruppe wechseln",
      applyConfigTemplate: "Konfigurationsvorlage anwenden",
      cancel: "Abbrechen",
      save: "Speichern",
      addBracelets: "Funksender hinzufügen",
    },
    general: {
      firmware: "Firmware Version",
      modem: "Mobilfunkstatus",
      wifi: "WiFi Status",
      battery: "Batteriestatus",
      dailyCheckIn: "Tagestaste",
    },
    events: {
      pageTitle: "Geräteereignisse",
      header: {
        type: "Veranstaltung",
        timestamp: "Zeitstempel",
      },
      empty: "Keine Veranstaltungen verfügbar",
    },
    feature: {
      header: {
        featureFlags: "Caru Care Funktionen ein-/ausstellen",
        developmentSettings: "Entwicklungseinstellungen",
      },
      audio: "Audio: Lautstärke",
      cortex: "Cortex: Log Level",
    },
    settings: {
      general: "Allgemein",
      alertDestinations: "Notrufeinstellungen",
      bracelets: "Funksender",
      events: "Veranstaltungen",
      features: "Zusatzfunktionen",
    },
    tooltip: {
      braceletPresenceStatus: "Funksender Funkstrecken",
      dailyCheckIn: "Tagestaste",
      braceletBatteryStatus: "Funksender Batterie",
      presenceStatus: "Basisstation Cloud Verbindung",
      wifiStatus: "Basisstation WLAN",
      powerSupplyStatus: "Basisstation Stromversorgung",
    },
    placeholder: "Geräte ID suchen",
    loading: "Geräte werden geladen...",
    errorStatus: {
      ok: "OK",
      error: "Fehler",
      unknown: "Unbekannt",
      off: "Ausgeschaltet",
      emptyBattery: "Akku leer",
      missingDevice: "Offline",
      lowPowerMode: "Stromsparmodus",
    },
  },
  notification: {
    deviceReset: "Zurücksetzen des Geräts ist gestartet...",
    deviceDiagnosis: "Geräteselbsttest ist gestartet...",
    deviceRefresh: "Gerät {serialNumber} ist aktualisiert",
    header: {
      plugoutNotifications: "Benachrichtigung bei Stromausfall",
    },
    form: {
      sms: "SMS",
      email: "E-Mail",
    },
    action: {
      addNotificationReceiver: "Empfänger hinzufügen",
    },
  },
  user: {
    listPageTitle: "Nutzerverwaltung",
    detailsPageTitle: "Nutzerkonto",
    header: {
      name: "Name",
      tenant: "Kundengruppe",
      role: "Nutzerrechte",
      edit: "Bearbeiten",
    },
    form: {
      permissions: "Nutzerrechte",
      roles: {
        none: "Kein Zugriff",
        viewer: "Nur Ansicht",
        admin: "Admin",
      },
    },
    placeholder: "Geräte Suchen",
  },
  alert: {
    applyNotificationTitle: "Konfiguration der Benachrichtigungen speichern ?",
    applyAlarmTitle: "Notrufkonfiguration speichern ?",
    applyGroupTitle: "Gruppen Zugehörigkeit speichern ?",
    applyOwnerTitle: "Kundengruppen Zugehörigkeit speichern ?",
    resetDeviceTitle: "Gerät zurücksetzen",
    applyBatchResetTitle: "Geräte zurücksetzen",
    applyBatchRebootTitle: "Geräte neu starten",
    applyBatchShutdownTitle: "Geräte herunterfahren",
    applyBatchDeactivateTitle: "Geräte deaktivieren",
    applyChangesTitle: "Änderungen bestätigen",
    leavePage: "Seite verlassen",
    applyBatchResetDescription:
      "Möchten Sie die ${length} Geräte wirklich zurücksetzen? Diese Aktion kann nicht Rückgängig gemacht werden.",
    applyBatchRebootDescription: "Möchten Sie die ${length} Geräte wirklich neu starten?",
    applyBatchShutdownDescription: "Möchten Sie die ${length} Geräte wirklich herunterfahren?",
    applyBatchDeactivateDescription: "Möchten Sie die ${length} Geräte wirklich deaktivieren?",
    applyNotificationDescription:
      "Möchten Sie diese Benachrichtigungs Einstellungen auf alle Geräte anwenden? Die bestehenden Einstellungen werden dabei überschrieben. Diese Aktion kann nicht rückgängig gemacht werden.",
    applyAlarmDescription:
      "Möchten Sie diese Notruf Einstellungen auf alle Geräte anwenden? Die bestehenden Notruf Einstellungen werden dabei überschrieben. Diese Aktion kann nicht rückgängig gemacht werden.",
    applyGroupDescription:
      "Möchten Sie den Gruppenname auf alle Geräte anwenden? Der bestehenden Gruppenname wird dabei überschrieben. Diese Aktion kann nicht rückgängig gemacht werden",
    applyOwnerDescription:
      "Möchten Sie diese Einstellung auf alle Geräte anwenden? Die bestehende Einstellung wird dabei überschrieben. Diese Aktion kann nicht rückgängig gemacht werden.",
    resetDeviceDescription:
      "Möchten Sie dieses Gerät wirklich zurücksetzen? Diese Aktion kann nicht rückgängig gemacht werden.",
    applyChangesDescription: "Möchten Sie die Änderungen wirklich übernehmen?",
    leavePageDescription: "Sie haben ungesicherte Änderungen. Sind Sie sicher, dass Sie die Seite verlassen wollen?",
    deleteTemplateTitle: "Vorlage Löschen?",
    deleteTemplateDescription: "Sind Sie sicher, dass die Vorlage gelöscht werden soll?",
    rebootDeviceDescription: "Sind Sie sicher, dass sie das Gerät neu starten wollen?",
  },
  configuration: {
    header: {
      config: "Einstellungen",
    },
    expertMode: "Expert Mode",
    editJson: "Edit Json",
  },
  safety: {
    header: {
      safety: "Sicherheit",
    },
  },
  health: {
    header: {
      health: "Gesundheit",
    },
  },
  system: {
    header: {
      system: "System",
      volumeSettings: "Gerätelautstärke",
    },
    volume: {
      quiet: "leise",
      default: "normal",
      loud: "laut",
    },
  },
  scaip: {
    form: {
      header: "Geräte ID Einstellungen",
      controllerId: "Geräte ID",
      callerId: "Anrufer ID",
      errorControllerId: "Kontroller ID darf nur aus Großbuchstaben und Zahlen bestehen",
    },
  },
  userManagement: {
    listPageTitle: "Benutzerverwaltung",
    tab: {
      user: "Benutzer",
      tenants: "Organisation",
      inviteUser: "Benutzer einladen",
      editUser: "Benutzer bearbeiten",
      createTenant: "Tenant erstellen",
      updateTenant: "Tenant bearbeiten",
    },
    userTable: {
      name: "Name",
      email: "E-Mail",
      phone: "Telefonnummer",
      tenants: "Organisation",
      role: "Rolle",
      state: "Status",
    },
    tenantTable: {
      name: "Name",
      slug: "Slug",
      devices: "Geräte",
      serialNumber: "Seriennummer",
      users: "Benutzer",
      deviceTenants: "Geräte der Organisation",
      newDevices: "Neue Geräte",
      tenantExists: "Der Name der Organisation wird schon benutzt",
    },
    action: {
      inviteUser: "Benutzer Einladen",
      inviteUserDescription:
        "Bitte bestätigen Sie, dass Sie den Benutzer hinzufügen möchten. Eine E-Mail mit einem temporären Passwort wird an den neuen Benutzer gesendet.",
      deleteUser: "Benutzer Löschen",
      deleteUserDescription: "Sind Sie sicher, dass der Benutzer {email} gelöscht werden soll?",
      updateUser: "Benutzer Ändern",
      updateUserDescription: "Sind Sie sicher, dass der Benutzer geändert werden soll?",
      createTenant: "Organisation erstellen",
      createTenantDescription: "Sind Sie sicher, dass Sie die Organisation erstellen wollen?",
      updateTenant: "Organisation bearbeiten ",
      updateTenantDescription: "Sind Sie sicher, dass Sie die Änderungen speichern wollen?",
    },
  },
  configTemplates: {
    listPageTitle: "Konfigurationsvorlagen",
    listPageTitleEdit: "Konfigurationsvorlage",
    header: {
      id: "Id",
      name: "Name",
      placeholder: "Platzhalter",
      lastUpdate: "Letztes Update",
      lastUpdateBy: "Letzte Änderung",
      owner: "Besitzer",
      applier: "Anwender",
      edit: "Bearbeiten",
      template: "Template",
      preview: "Vorschau",
      example: "Beispielwert",
      noIdFound: "Keine Controller ID gefunden",
    },
    loadPreviousControllerIds: "Vorherige Controller IDs laden",
    loadPreviousControllerId: "Vorherige Controller ID laden",
    templateDescription: "Platzhalter starten und enden mit '$'.",
  },
  deviceAlarmsNotificationSubscription: {
    listPageTitle: "E-Mail Benachrichtigungen",
    listPageTitleEdit: "E-Mail Benachrichtigungen",
    emailList: "E-Mail Adresse eingeben",
    emailListInputFieldText: "E-Mail Adresse hinzufügen und Enter drücken oder eine Liste einfügen",
    emailListDescription:
      "Sie können mehrere E-Mail Adressen hinzufügen, indem Sie eine durch Komma, Leerzeichen oder Zeilenumbruch getrennte Liste einfügen.",
    selectTenant: "Organisation wählen",
    noTenant: "Ihnen sind keine Mandanten zugewiesen.",
    excludedDevice: "Ausgeschlossene Geräte",
    excludedDeviceInputField: "Seriennummer eingeben zum Suchen",
    excludedDeviceDescription: "Nur Kleinbuchstaben und Zahlen (8 Zeichen). Sie können auch eine Liste einfügen.",
    searchingDevices: "Geräte werden geladen...",
    invalidDeviceId: "Die Geräte-ID muss genau 8 alphanumerische Zeichen enthalten (a-z, 0-9).",
    duplicateDeviceId: "Dieses Gerät wurde bereits hinzugefügt.",
    deviceNotFoundInTenant: "Gerät wurde in der ausgewählten Organisation nicht gefunden.",
    subscriptionStatusSlider: "Abo-Status",
    popups: {
      delete: {
        title: "Löschung Bestätigen",
        description:
          "Möchten Sie diese Benachrichtigungseinstellungen wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        actionText: "Löschen",
      },
      create: {
        title: "Speichern Bestätigen",
        description:
          "Möchten Sie diese Einstellungen wirklich speichern? (Alle Empfänger Ihrer Benachrichtigungsliste werden benachrichtigt)",
        actionText: "Speichern",
      },
      update: {
        title: "Aktualisierung Bestätigen",
        description: "Möchten Sie die Änderungen speichern?",
        actionText: "Bestätigen",
      },
      abort: {
        title: "Stornierung bestätigen",
        description:
          "Möchten Sie nicht gespeicherte Änderungen wirklich verwerfen? Diese Aktion kann nicht rückgängig gemacht werden.",
        actionText: "Bestätigen",
      },
    },
  },
  alarm: {
    listPageTitle: "Alarmzentralen",
    header: {
      name: "Name",
      tenant: "Kundengruppe",
      alertTriggers: "Notrufauslösemöglichkeiten konfigurieren",
      alarmDestinations: "Notrufempfänger",
    },
    destination: {
      pstn: "PSTN",
      sip: "SIP",
      arc: "Notrufzentrale",
      isArc: "Ist Notrufzentrale",
      arcName: " ARC-Name (SCAIP-Server-Address)",
    },
    form: {
      name: "Name",
      host: "Host",
      port: "Port",
      username: "Nutzername",
      password: "Passwort",
      tenant: "Kundengruppe",
      changeTenant: "Kundengruppe ändern",
      country: {
        caru: "CARU",
        caritasSoest: "Caritas Soest",
      },
      selectArc: "-- Notruf Zentrale auswählen --",
      triggerByVoice: "Notrufauslösung über die Stimme (Hilfe, Hilfe)",
      triggerByTouch: "Notrufauslösung durch Berühren des Deckels am Gerät",
      triggerByBracelet: "Notrufauslösung durch Sturzerkennung",
      triggerByVoiceOnBattery: "Im Batterie Modus aktiv",
      triggerByVoiceOnBatteryActive: "Die Batterie hält ca. 2h",
      triggerByVoiceOnBatteryInactive: "Die Batterie hält ca. 24h",
    },
    action: {
      addDestination: "Notrufkontakt hinzufügen",
    },
    tooltip: {
      triggerByVoiceOnBatteryActive:
        "Die Notrufauslösung über die Stimme wird während eines Stromunterbruchs deaktiviert, um den Batterie-Verbrauch zu minimieren und die Zeit zur Überbrückung des Unterbruches zu maximieren. Während eines Stromunterbruches kann kein Notruf über die Stimme ausgelöst werden. Notrufe können weiterhin über den Funksender und am CARU care ausgelöst werden.",
      triggerByVoiceOnBatteryInactive:
        "Die Notrufauslösung über die Stimme ist auch während eines Stromunterbruches möglich. Durch den Stromverbrauch der Spracherkennung ist die Zeit zur Überbrückung des Unterbruches beschränkt.",
    },
  },
  dailyCheck: {
    status: {
      ok: "OK",
      disabled: "Deaktiviert",
      missing: "Nicht bestätigt",
      suspended: "Pausiert",
      unknown: "Unbekannt",
    },
    form: {
      active: "Aktiv",
      inactive: "Inaktiv",
      suspended: "Pausiert",
      suspendedDate: "Pausiert bis",
      checkTime: "Startzeit (hh:mm)",
      gracePeriod: "Bestätigungsfenster (min)",
      remindersDescription: "Erinnerung wird nach {firstReminder} und {secondReminder} Minuten abgespielt",
    },
  },
  hydrationReminder: {
    titleDescription: "Die Klänge werden um folgenden Zeiten abgespielt: {animationSlot} ",
    reminderInterval: "Wiedergabe-Intervall einstellen",
    intervalSelection: "Wiedergabe-Zeitfenster einstellen",
    intervalDescription: "Erinnerungen werden nur in den festgelegten Zeitfenstern abgespielt.",
    intervalPreviewDescription: "Reminders are played around:",
    previewSound: "Vorschau des Klangs",
    previewSoundDescription: "Klang wird nur im Browser abgespielt",
    play: "Abspielen",
    updateVersion:
      "Diese Funktionalität ist ab der Version 2023.3.3 verfügbar. Bitte kontaktieren Sie unseren Support, um diese Version auf Ihrem Gerät zu installieren.",
  },
  events: {
    header: {
      events: "Letzte Geräte Meldungen",
    },
  },
  presence: {
    window: {
      "15min": "Kurzzeitig erkannt (15 Min)",
      "1h": "Mittelfristig erkannt (1 Std)",
      "27h": "Langfristig erkannt (27 Std)",
    },
  },
  stateAlarms: {
    label: {
      deviceReportedStates: "Geräte Meldungen",
      cloudReportedStates: "Cloud Meldungen",
      powerSupplyStates: "Batteriebetrieb",
      braceletPresenceStates: "Funksender Meldungen",
      braceletBatteryStates: "Funksender Batteriestand",
      deviceReportedState: "Basisstation Geräte Verbindung",
      cloudReportedState: "Basisstation Cloud Verbindung",
      powerSupplyState: "Stromversorgung",
      braceletPresenceState: "Funksender",
      braceletBatteryState: "Funksender Batterie",
      dailyCheckIn: "Tagestaste",
      missingDeviceDueBattery: "Basisstation offline (Batterie leer)",
      missingDeviceDueUnknown: "Basisstation offline (anderer Grund)",
      interruptedPower: "Basisstation in Batteriebetrieb",
      missingBracelets: "Funksender Heartbeat fehlt",
      braceletBattery: "Funksender Batteriestand kritisch",
      wifiConnection: "Wifi Verbindung",
    },
    deviceReportedPresence: {
      online: "Online",
      offlineBatteryEmpty: "Offline leerer Akku",
      offlineLowPowerMode: "Offline Wenig Batterie",
      offlineTurnedOff: "Offline Ausgeschalten",
      unknown: "Unbekannt",
    },
    cloudReportedPresence: {
      online: "Online",
      offlineUnknown: "Offline Unbekannt",
      offlineDeviceInitiated: "Offline Gerät initiiert",
      offlineCloudInitiated: "Offline Cloud initiiert",
      unknown: "Unbekannt",
    },
    powerSupply: {
      connected: "Verbunden",
      disconnected: "Unterbrochen",
      unknown: "Unbekannt",
      rebooting: "Wird neu gestartet",
    },
    braceletPresence: {
      inRange: "In Reichweite",
      outOfRange: "Außer Reichweite",
      unknown: "Unbekannt",
    },
    braceletBattery: {
      ok: "Ok",
      critical: "Kritisch",
      unknown: "Unbekannt",
    },
    dailyCheckIn: {
      active: "Aktiv",
      deactivated: "Deaktiviert",
      pausedByDevice: "Pausiert durch den Benutzer",
      pausedByPlatform: "Pausiert durch die  Plattform",
      missing: "Fehlt",
      unknown: "Unbekannt",
    },
    notifications: {
      maxAmountTitle: "Maximum Filter",
      maxAmount: "Es können maximal drei Filter verwendet werden. Bitte löschen Sie einen um einen neuen hinzuzufügen",
    },
  },
  error: {
    filter: {
      label: {
        deviceReportedStates: "Geräte Meldungen",
        cloudReportedStates: "Cloud Meldungen",
        powerSupply: "Batteriebetrieb",
        braceletStates: "Funksender Meldungen",
        braceletBatteryState: "Funksender Batteriestand",
        dailyCheckIn: "Tagestaste",
        missingDeviceDueBattery: "Basisstation offline (Batterie leer)",
        missingDeviceDueUnknown: "Basisstation offline (anderer Grund)",
        interruptedPower: "Basisstation in Batteriebetrieb",
        missingBracelets: "Funksender Heartbeat fehlt",
        braceletBattery: "Funksender Batteriestand kritisch",
      },
      state: {
        online: "Online",
        offline: "Offline",
        offlineLowPower: "Offline Wenig Batterie",
        offlineTurnedOff: "Offline Ausgeschalten",
        offlineDeviceInitiated: "Offline Gerät initiiert",
        offlineCloudInitiated: "Offline Cloud initiiert",
        connected: "Verbunden",
        disconnected: "Unterbrochen",
        inRange: "In Reichweite",
        outOfRange: "Außer Reichweite",
        ok: "Ok",
        critical: "Kritisch",
        deactivated: "Deaktiviert",
        active: "Aktive",
        pausedByCloud: "Pausiert von Cloud",
        pausedByUser: "Pausiert von User",
        missing: "Fehlt",
        missingBracelets: "Funksender Heartbeat fehlt ",
        braceletBattery: "Funksender Batteriestand kritisch",
      },
      actionLabel: {
        missingDeviceDueBattery: "Liste anzeigen",
        missingDeviceDueUnknown: "Liste anzeigen",
        interruptedPower: "Liste anzeigen",
        missingBracelets: "Liste anzeigen",
        braceletBattery: "Liste anzeigen",
      },
    },
    unknown: "Unbekannter Fehler",
    notFound: "Nicht gefunden",
    searchDevice: "Bitte geben Sie die Geräte-ID ein",
    destinationEmpty: "Der Alarmempfänger darf nicht leer sein",
    receiverEmpty: "Der Alarmempfänger darf nicht leer sein",
    braceletEmpty: "Das Funksendernummern-Feld darf nicht leer sein",
    braceletFormat:
      "Die Funksendernummer ist nicht gültig: Sie muss eine 12- oder 14-Stellige Nummer sein. Beispiele: 006569866354 (Vibby Oak) oder 2435003426474A (Vibby Oak S)",
    braceletDuplicate: "Funksendernummern müssen eindeutig sein. Eingetragene Werte sind Duplikate.",
    braceletNotSupported:
      "Vibby Oak S werden mit der installierten Gerätesoftware nicht unterstützt. Bitte kontaktieren Sie unseren Support für ein Software Update.",
    sipAddressFormat: "Keine korrektes SIP Adressformat. Bitte folgendes Format verwenden: nutzer@host.com",
    phoneNumberFormat: "Kein gültiges Rufnummernformat. Bitte wie folgt eingeben: 004178021212",
    emailFormat: "Die E-Mail-Adresse ist nicht gültig. Erwartetes Format: user@host.com",
    empty: "Das Rufnummerfeld darf nicht leer sein",
    permissions: "Berechtigungsfehler",
    permissionsDescription: "Ihnen fehlen die erforderlichen Berechtigungen, um die Aktion auszuführen.",
  },
  search: {
    placeholder: "Geräte suchen",
  },
  profileMenu: {
    signOut: "Abmelden",
  },
  filters: {
    all: "Alle",
    operationStatus: "Statusmeldungen",
    allOk: "Alles OK",
    offline: "Offline",
    deviceNotifications: "Meldung Basisstation",
    batteryPowered: "Basisstation im Batteriebetrieb",
    batteryEmpty: "Batterie leer",
    braceletNotifications: "Meldung Funksender",
    batteryLow: "Funksender Batterie schwach",
    braceletOutOfRange: "Funksender außer Reichweite",
    off: "Ausgeschaltet",
    dailyCheckIn: "Tagestaste",
    dailyCheckInActive: "Tagestaste aktiv",
    dailyCheckInMissing: "Tagestaste nicht bestätigt",
    dailyCheckInPaused: "Tagestaste pausiert",
    dailyCheckInByUser: "Durch den Benutzer",
    dailyCheckInPlatform: "Durch die Plattform",
    dailyCheckInDeactivated: "Inaktiv",
    healthNotifications: "Gesundheitsleistungen",
    healthNotificationsCo2: "CO2 Ampel",
    healthNotificationsDrink: "Trinkerinnerung",
    bracelet: "Funksender",
    error: "Fehler",
  },
  alarms: {
    alarm: "Alarme",
    sidebar: {
      critical:
        "Die Dringlichkeit 'Kritisch' zeigt an, dass ein schwerwiegendes Problem aufgetreten ist. Eine sofortige Abhilfemaßnahme ist erforderlich.",
      major:
        "Die Dringlichkeit 'Erheblich' zeigt an, dass ein Problem aufgetreten ist, welches erste Funktionen beeinträchtigt. Eine zeitnahe Abhilfemaßnahme ist erforderlich.",
      minor:
        "Die Dringlichkeit 'Gering' zeigt an, dass ein Problem erkannt wurde, welches jedoch die Funktion noch nicht beeinträchtigt. Es sollten Maßnahmen ergriffen werden, um zu verhindern, dass es sich zu einem schwerwiegenden Problem entwickelt.",
      warning:
        "Die Dringlichkeit 'Warnung' zeigt an, dass ein mögliches Problem erkannt wurde, bevor nennenswerte Auswirkungen zu spüren sind. Es sollten Maßnahmen ergriffen werden, um es besser zu verstehen und zu verhindern, dass es schlimmer wird.",
    },
    headers: {
      description: "Beschreibung",
      urgency: "Dringlichkeit",
      measures: "Empfohlene Maßnahmen",
      updatedat: "Letzte Aktualisierung",
    },
    levels: {
      not_applicable: "Unbekannt",
      unknown: "Unbekannt",
      normal: "Keine",
      warning: "Warnung",
      minor: "Gering",
      major: "Erheblich",
      critical: "Kritisch",
    },

    network: {
      modem_link: {
        title: "Mobilfunk-Verbindung",
        not_applicable: {
          description: "Der Zustand der Mobilfunk-Verbindung ist unbekannt.",
          urgency: "Da das CARU care offline ist, kann der Zustand der Mobilfunk-Verbindung nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Der Zustand der Mobilfunk-Verbindung ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Das CARU care ist über das Mobilfunknetz mit dem Internet verbunden.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description:
            "Die Verbindung mit dem Internet über das Mobilfunknetz ist unterbrochen (weniger als 15 Minuten).",
          urgency:
            "Das CARU care ist nur über Wifi mit dem Internet verbunden und es versucht selbständig, die Verbindung zum Mobilfunknetz wiederherzustellen.",
          measures: "Keine",
        },
        minor: {
          description: "Die Verbindung mit dem Internet über das Mobilfunknetz ist unterbrochen (mehr als 15 Minuten).",
          urgency:
            "Es ist dem CARU care bisher nicht gelungen, sich selbstständig wieder mit dem Mobilfunknetz zu verbinden. Es versucht es weiterhin.",
          measures:
            "Bitte prüfen Sie den Standort des Gerätes vor Ort. Eine Umplatzierung des Gerätes kann zur Wiederherstellung der Mobilfunk-Verbindung führen.",
        },
      },
      modem_connection_quality: {
        title: "Mobilfunk-Verbindungsqualität",
        not_applicable: {
          description: "Die Qualität der Verbindung zum Internet über das Mobilfunknetz ist unbekannt.",
          urgency: "Da das Gerät offline ist, kann die Qualität der Verbindung nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Die Qualität der Verbindung zum Internet über das Mobilfunknetz ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Die Qualität der Verbindung zum Internet über das Mobilfunknetz ist exzellent.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description: "Die Qualität der Verbindung zum Internet über das Mobilfunknetz ist ausreichend.",
          urgency:
            "Die Verbindungsqualität ist nicht optimal, es ist jedoch mit keiner Einschränkung der Sprachqualität zu rechnen.",
          measures: "Keine",
        },
        minor: {
          description: "Die Qualität der Verbindung zum Internet über das Mobilfunknetz ist bescheiden.",
          urgency:
            "Die Verbindungsqualität ist ausreichend für den Aufbau einer Sprechverbindung, es können jedoch Verzögerungen und Unterbrüchen auftreten.",
          measures:
            "Um eine stabile Sprechverbindung zu gewährleisten, sollte das CARU care umplatziert werden, falls kein Wifi hinterlegt ist.",
        },
      },
      network_cloud_reported: {
        title: "Cloud-Verbindung",
        not_applicable: {
          description: "Das CARU care wurde heruntergefahren.",
          urgency: "",
          measures: "Keine",
        },
        unknown: {
          description: "Der Status der Verbindung zur CARU platform ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Das CARU care ist mit der CARU platform verbunden.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description: "Die Verbindung des CARU care zur CARU platform ist unterbrochen (weniger als 15 Minuten).",
          urgency: "Das CARU care versucht selbständig, die Verbindung zur CARU platform wiederherzustellen.",
          measures: "Keine",
        },
        major: {
          description: "Die Verbindung des CARU care zur CARU platform ist unterbrochen (weniger als 1 Stunde).",
          urgency:
            "Das Absetzen von Notrufen ist nicht möglich, da das CARU care nicht mit dem Internet verbunden ist.",
          measures:
            "Die Ursache des Verbindungsproblems muss ermittelt werden. Da die Verbindung zur CARU platform unterbrochen ist, muss der CARU care Benutzer kontaktiert werden.",
        },
        critical: {
          description: "Die Verbindung des CARU care zur CARU platform ist unterbrochen (mehr als 1 Stunde).",
          urgency:
            "Das Absetzen von Notrufen ist nicht möglich, da das CARU care nicht mit dem Internet verbunden ist.",
          measures:
            "Die Ursache des Verbindungsproblems muss ermittelt werden. Da die Verbindung zur CARU platform unterbrochen ist, muss der CARU care Benutzer kontaktiert werden.",
        },
      },
      network_arc_reported: {
        title: "Zentralen-Kontrollruf",
        not_applicable: {
          description: "Der Kontrollruf-Status ist unbekannt.",
          urgency:
            "Da das CARU care offline ist oder keine Alarmzentralen konfiguriert hat, kann der Kontrollruf-Status nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Der Kontrollruf-Status ist unbekannt. ",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Der letzte Kontrollruf zu mindestens einer der konfigurierten Zentralen war erfolgreich.",
          urgency: "",
          measures: "Keine",
        },
        major: {
          description:
            "Der letzte erfolgreiche Kontrollruf zu einer der konfigurierten Zentralen war vor mehr als 3 Stunden.",
          urgency:
            "Das Absetzen von Notrufen zu der Zentrale ist nicht möglich, da das CARU care keine Antwort auf den Kontrollruf via SCAIP erhalten hat.",
          measures:
            "Überprüfen Sie die Konfiguration des Gerätes (insbesondere die Geräte ID) und fragen Sie bei Ihrer Zentrale nach, ob eine Störung bekannt ist.",
        },
        critical: {
          description:
            "Der letzte erfolgreiche Kontrollruf zu einer der konfigurierten Zentralen war vor mehr als 6 Stunden.",
          urgency:
            "Das Absetzen von Notrufen zu der Zentrale ist nicht möglich, da das CARU care keine Antwort auf den Kontrollruf via SCAIP erhalten hat.",
          measures:
            "Überprüfen Sie die Konfiguration des Gerätes (insbesondere die Geräte ID) und fragen Sie bei Ihrer Zentrale nach, ob eine Störung bekannt ist.",
        },
      },
    },
    wifi: {
      wifi_link: {
        title: "Wifi-Verbindung",
        not_applicable: {
          description: "Der Zustand der Wifi-Verbindung ist unbekannt.",
          urgency:
            "Da das CARU care offline oder kein Wifi konfiguriert ist, kann der Zustand der Wifi-Verbindung nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Der Zustand der Wifi-Verbindung ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Das CARU care ist über Wifi mit dem Internet verbunden.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description: "Die Verbindung mit dem Internet über das Wifi ist unterbrochen (weniger als 15 Minuten).",
          urgency:
            "Das CARU care ist über Mobilfunk mit dem Internet verbunden und versucht selbständig, die Verbindung zum Wifi wiederherzustellen.",
          measures: "Keine",
        },
        minor: {
          description: "Die Verbindung mit dem Internet über das Wifi ist unterbrochen (mehr als 15 Minuten).",
          urgency:
            "Das CARU care ist über Mobilfunk mit dem Internet verbunden und es ist dem CARU care bisher nicht gelungen, sich selbstständig wieder mit dem Wifi zu verbinden. Es versucht es weiterhin.",
          measures:
            "Bitte prüfen Sie die Wifi-Konfiguration und die Verbindung vor Ort. Eventuell ist das Wifi ausgefallen oder das Gerät befindet sich an einem ungünstigen Standort.",
        },
      },
      wifi_connection_quality: {
        title: "Wifi-Verbindungsqualität",
        not_applicable: {
          description: "Die Qualität der Verbindung zum Internet über das Wifi ist unbekannt.",
          urgency: "Da das Gerät offline ist, kann die Qualität der Verbindung nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Die Qualität der Verbindung zum Internet über das Wifi ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Die Qualität der Verbindung zum Internet über das Wifi ist exzellent.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description: "Die Qualität der Verbindung zum Internet über das Wifi ist ausreichend.",
          urgency:
            "Die Verbindungsqualität ist nicht optimal, es ist jedoch mit keiner Einschränkung der Sprachqualität zu rechnen.",
          measures: "Möglicherweise hilft die Umplatzierung des CARU care, die Verbindungsqualität zu verbessern.",
        },
        minor: {
          description: "Die Qualität der Verbindung zum Internet über das Wifi ist bescheiden.",
          urgency:
            "Die Verbindungsqualität ist ausreichend für den Aufbau einer Sprechverbindung, es ist jedoch mit Verzögerungen und Unterbrüchen zu rechnen.",
          measures:
            "Um eine stabile Sprechverbindung zu gewährleisten, sollte das CARU care umplatziert oder die Wifi-Konfiguration entfernt werden.",
        },
      },
    },
    power: {
      power_supply: {
        title: "Stromversorgung",
        not_applicable: {
          description: "Der Status der Stromversorgung ist unbekannt. ",
          urgency: "Da das CARU care offline ist, kann der Status der Stromversorgung nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Der Status der Stromversorgung ist unbekannt. ",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Das CARU care ist mit dem Stromnetz verbunden.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description: "Die Stromversorgung des CARU care ist für weniger als 15 Minuten unterbrochen.",
          urgency: "Das CARU care läuft im Batterie-Betrieb und kann kurze Stromunterbrüche problemlos überbrücken.",
          measures: "Keine",
        },
        major: {
          description: "Die Stromversorgung des CARU care ist für mehr als 15 Minuten unterbrochen.",
          urgency: "Das CARU care läuft im Batterie-Betrieb, die Laufzeit der Batterie ist jedoch nicht unbegrenzt.",
          measures:
            "Maßnahmen zur Wiederherstellung der Stromversorgung müssen ergriffen werden, falls keine Stromausfälle bekannt sind.",
        },
      },
      battery_fault: {
        title: "Batteriezustand",
        not_applicable: {
          description: "Der Zustand der Batterie ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        unknown: {
          description: "Der Zustand der Batterie ist unbekannt.",
          urgency: "",
          measures: "Keine",
        },
        normal: {
          description: "Batteriezustand des CARU care ist normal.",
          urgency: "",
          measures: "Keine",
        },
        minor: {
          description: "Das CARU care meldet einen tiefen Ladestand.",
          urgency: "Die Laufzeit des CARU care im Batteriebetrieb ist eingeschränkt.",
          measures: "Die Batterie muss genauer analysiert werden. Bitte kontaktieren Sie den CARU Kundendienst.",
        },
      },
    },
    low_power_mode: {
      title: "Cloud-Verbindung (Gerät im Stromsparmodus)",
      warning: {
        description:
          "Das CARU care befindet sich im Batteriebetrieb und der Stromsparmodus ist eingeschaltet. Um die Batterielaufzeit zu erhöhen, ist die Cloud-Verbindung unterbrochen worden.",
        urgency:
          "Das Absetzen von Notrufen ist weiterhin möglich. Nach dem Absetzen eines Notrufs, verbindet sich das CARU care mit der Cloud und erstellt eine Telefonverbindung.",
        measures:
          "Kontaktieren Sie den Benutzer und stellen Sie sicher, dass das CARU care Gerät mit dem Stromnetz verbunden ist. So wird eine permanente Verbindung zur Cloud aufrechterhalten.",
      },
      major: {
        description:
          "Das CARU care befindet sich im Batteriebetrieb und der Stromsparmodus ist eingeschaltet. Um die Batterielaufzeit zu erhöhen, ist die Cloud-Verbindung unterbrochen worden.",
        urgency:
          "Das Absetzen von Notrufen ist weiterhin möglich. Nach dem Absetzen eines Notrufs, verbindet sich das CARU care mit der Cloud und erstellt eine Telefonverbindung.",
        measures:
          "Kontaktieren Sie den Benutzer und stellen Sie sicher, dass das CARU care Gerät mit dem Stromnetz verbunden ist. So wird eine permanente Verbindung zur Cloud aufrechterhalten.",
      },
      critical: {
        description:
          "Das CARU care befindet sich im Batteriebetrieb und der Stromsparmodus ist eingeschaltet. Um die Batterielaufzeit zu erhöhen, ist die Cloud-Verbindung unterbrochen worden.",
        urgency:
          "Das Absetzen von Notrufen ist weiterhin möglich. Nach dem Absetzen eines Notrufs, verbindet sich das CARU care mit der Cloud und erstellt eine Telefonverbindung.",
        measures:
          "Kontaktieren Sie den Benutzer und stellen Sie sicher, dass das CARU care Gerät mit dem Stromnetz verbunden ist. So wird eine permanente Verbindung zur Cloud aufrechterhalten.",
      },
    },
    accessories: {
      bracelet_presence: {
        title: "Funksender-Kontrollmeldung",
        not_applicable: {
          description: "Der Kontrollmeldung-Status ist unbekannt. ",
          urgency:
            "Da das CARU care offline oder keine Funksender konfiguriert sind, kann der Kontrollmeldung-Status nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Der Kontrollmeldung-Status ist unbekannt. ",
          urgency:
            "Das CARU care ist seit weniger als 24h eingeschaltet (der Funksender sendet die Kontrollmeldung alle 23h) oder ein neuer Funksender wurde hinzugefügt.",
          measures: "Der Kontrollmeldung-Status kann durch eine Testauslösung mit allen Funksendern ermittelt werden.",
        },
        normal: {
          description: "Es wurde in den letzten 24 Stunden eine Kontrollmeldung von allen Funksendern empfangen.",
          urgency: "",
          measures: "Keine",
        },
        warning: {
          description:
            "Es wurde von mindestens einem Funksender in den letzten 24 Stunden keine Kontrollmeldung empfangen.",
          urgency:
            "Der Funksender hat sich zum Zeitpunkt der Kontrollmeldung (alle 23 Stunden) nicht in Reichweite der Basisstation befunden.",
          measures: "Keine",
        },
        minor: {
          description:
            "Es wurde von mindestens einem Funksender in den letzten 48 Stunden keine Kontrollmeldung empfangen.",
          urgency:
            "An zwei aufeinander folgenden Tagen hat sich der Funksender zum Zeitpunkt der Kontrollmeldung (alle 23 Stunden) nicht in Reichweite der Basisstation befunden.",
          measures:
            "Die Kontaktaufnahme zum Teilnehmer wird empfohlen. Durch Auslösen eines Testrufes am Funksender kann eine Fehlfunktion ausgeschlossen werden.",
        },
        major: {
          description:
            "Es wurde von mindestens einem Funksender in den letzten 72 Stunden keine Kontrollmeldung empfangen.",
          urgency:
            "An drei oder mehr aufeinander folgenden Tagen hat sich der Funksender zum Zeitpunkt der Kontrollmeldung (alle 23 Stunden) nicht in Reichweite der Basisstation befunden.",
          measures:
            "Bitte nehmen Sie Kontakt zum Teilnehmer auf. Durch Auslösen eines Testrufes am Funksender kann eine Fehlfunktion ausgeschlossen werden.",
        },
      },
      bracelet_battery: {
        title: "Funksenderbatterie",
        not_applicable: {
          description: "Der Zustand der Funksenderbatterie ist unbekannt.",
          urgency:
            "Da das CARU care offline oder keine Funksender konfiguriert sind, kann der Zustand der Batterie nicht ermittelt werden.",
          measures: "Keine",
        },
        unknown: {
          description: "Der Zustand der Funksenderbatterie ist unbekannt.",
          urgency: "Das CARU care war über längere Zeit ausgeschaltet oder ein neuer Funksender wurde hinzugefügt.",
          measures:
            "Der Zustand der Funksenderbatterie kann durch eine Testauslösung mit allen Funksendern ermittelt werden.",
        },
        normal: {
          description: "Der Zustand der Funksenderbatterie ist normal.",
          urgency: "",
          measures: "Keine",
        },
        minor: {
          description: "Ein Problem mit der Funksenderbatterie wurde erkannt.",
          urgency: "Die Batterie sollte ersetzt werden.",
          measures: "Ersetzen Sie die Batterie des Funksender.",
        },
        major: {
          description: "Ein Problem mit der Funksenderbatterie besteht seit 21 Tagen",
          urgency: "Die Batterie muss dringend ersetzt werden.",
          measures: "Ersetzen Sie die Batterie des Funksender.",
        },
        critical: {
          description: "Ein Problem mit der Funksenderbatterie besteht seit mehr als 28 Tagen",
          urgency: "Die Batterie muss dringend ersetzt werden.",
          measures: "Ersetzen Sie die Batterie des Funksender.",
        },
      },
    },
    title: "Technische Alarme",
    titlePower: "Stromversorgung",
    titleNetwork: "Verbindung",
    titleWifi: "Wifi",
    titleAccessories: "Funksender",
    power_supply: "Stromversorgung",
    battery_fault: "Batteriezustand",
    wifi_link: "Wifi-Verbindung",
    wifi_connection_quality: "Wifi-Qualität",
    modem_link: "Mobilfunk-Verbindung",
    modem_connection_quality: "Mobilfunk-Verbindungsqualität",
    bracelet_presence: "Funksenderpräsenz",
    bracelet_battery: "Funksenderbatterie",
    cloud_connection: "Cloud-Verbindung",
    mqtt_connection: "MQTT-Verbindung",
    network_cloud_reported: "Cloud-Verbindung",
    network_arc_reported: "Zentralen-Kontrollruf",
    unknown: "Unbekannt",
    normal: "Normal",
    warning: "Warnung",
    minor: "Geringfügig",
    major: "Erheblich",
    critical: "Kritisch",
    wifiNotConnected: "Wifi - Nicht verbunden",
    wifiConnected: "Verbunden",
    networkSelection: "Netzwerkauswahl",
    noNetwork: "Kein Netzwerk ausgewählt",
    noNetworkAvailable: "Kein Netzwerk verfügbar",
    pwdLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
    pwdLengthMax: "Das Passwort darf nicht länger als 63 Zeichen lang sein.",
  },
  navigationBar: {
    userManagement: "Benutzerverwaltung",
    configTemplates: "Konfigurationsvorlagen",
    alarmCenters: "Alarmzentralen",
    users: "Benutzer",
    docs: "CARU Academy",
    batteryReplacement: "CARU Revision",
    deviceAlarmsNotificationSubscription: "Email Benachrichtigungen",
  },
  common: {
    label: {
      useSetting: "Einstellungen übernehmen",
      since: "seit",
    },
    action: {
      cancel: "Abbrechen",
      save: "Speichern",
      edit: "Bearbeiten",
      apply: "Anwenden",
      leave: "Verlassen",
      delete: "Löschen",
      search: "Suche",
      clearAll: "Filter löschen",
      expandAll: "Alle ausklappen",
      collapseAll: "Alle einklappen",
      loadMore: "Mehr laden ...",
    },
    filter: {
      all: "Alle",
      errors: "Fehler",
      warnings: "Warnungen",
      info: "Info",
      user: "Benutzer",
      success: "Erfolgreich",
      selectEventTypes: "Kategorien wählen ...",
      selected: "Ausgewählte Kategorien",
    },
    noResults: "Keine Ergebnisse",
  },
  "crn::cortex.lifecycle.battery::event-type:critical": "Batterie Basisstation kritisch",
  "crn::cortex.lifecycle.bracelet::event-type:battery_critical": "Batterie des Funksenders niedrig",
  "crn::cortex.lifecycle.bracelet::event-type:heartbeat": "Funksender Heartbeat",
  "crn::cortex.lifecycle.bracelet::event-type:out_of_range": "Keine Verbindung zum Funksender",
  "crn::cortex.lifecycle.system::event-type:booted": "Geräte-Software gestartet",
  "crn::cortex.lifecycle.system::event-type:bottom_button": "Basisstation Nutzer ausgeschaltet",
  "crn::cortex.lifecycle.system::event-type:shutdown": "Herunterfahren der Basisstation",
  "crn::cortex.lifecycle.system::event-type:reboot": "Geräte-Software wird neu gestartet",
  "crn::cortex.lifecycle.wall_adapter::event-type:connected": "Stromverbindung Basisstation wiederhergestellt",
  "crn::cortex.lifecycle.wall_adapter::event-type:disconnected": "Stromverbindung Basisstation unterbrochen",
  "crn::cortex.lifecycle::event-type:arc_call_v2": "Notruf initiiert",
  "crn::cortex.lifecycle.daily_check_in::event-type:activated": "Tagestaste eingeschaltet",
  "crn::cortex.lifecycle.daily_check_in::event-type:deactivated": "Tagestaste ausgeschaltet",
  "crn::cortex.lifecycle.daily_check_in::event-type:requested": "Tagestaste aktiv",
  "crn::cortex.lifecycle.daily_check_in::event-type:reminded": "Tagestasten-Erinnerung abgespielt",
  "crn::cortex.lifecycle.daily_check_in::event-type:done": "Tagestaste von Nutzer betätigt",
  "crn::cortex.lifecycle.daily_check_in::event-type:missing": "Tagestastebestätigung fehlt",
  "crn::cortex.lifecycle.daily_check_in::event-type:suspended_by_platform": "Tagestaste: Plattform pausiert",
  "crn::cortex.lifecycle.daily_check_in::event-type:resumed_by_platform": "Tagestaste: Pausierung aufgehoben Plattform",
  "crn::cortex.lifecycle.daily_check_in::event-type:suspended_by_device": "Tagestaste: Nutzer pausiert",
  "crn::cortex.lifecycle.daily_check_in::event-type:resumed_by_device": "Tagestaste: Pausierung aufgehoben Nutzer",
  "crn::cortex.lifecycle.battery::event-type:fault": "Geräte-Batterie Fehler",
  "crn::cortex.lifecycle.system::event-type:low_power_enter": "Stromsparmodus gestartet",
  "crn::cortex.lifecycle.system::event-type:low_power_exit": "Stromsparmodus beendet",
  "crn::cortex.lifecycle.bracelet::event-type:fall_detected": "Funksender Sturzerkennung",
  "crn::cortex.lifecycle.bracelet::event-type:button_pressed": "Funksender Taste gedrückt",
  "crn::cortex.lifecycle.bracelet::event-type:bind": "Funksender Taste lange gedrückt",
  "crn::core.device_presence::event-type:connection_established": "Cloud-Verbindung hergestellt",
  "crn::core.device_presence::event-type:connection_lost": "Cloud-Verbindung unterbrochen",
  "crn::cortex.apps.alarm_trigger_test_mode::event-type:started": "Alarm-Testmodus gestartet",
  "crn::cortex.apps.alarm_trigger_test_mode::event-type:ended": "Alarm-Testmodus beendet",
  "crn::cortex.apps.aladdin::event-type:started": "Übungsprogramm gestartet",
  "crn::cortex.apps.aladdin::event-type:ended": "Übungsprogramm beendet",
  "crn::cortex.lifecycle::event-type:device_alarm_state": "Gerätealarmstatus aktualisiert",
  "crn::cortex.metrics::event-type:modem": "Modem Info",
  "crn::cloud.device_state_alarms::event-type:device_state_alarms_updated": "Alarme aktualisiert",
  "crn::cortex.lifecycle.bracelet::event-type:battery_ok": "Funksender Battery OK",
  "crn::cortex.lifecycle.hydration_reminder::event-type:played": "Trinkerinnerung gespielt",
  "crn::cortex.lifecycle.trigger::event-type:connectivity_check": "Konnektivitätsprüfung",
  "crn::cortex.lifecycle.trigger::event-type:hard_reboot": "Harter Neustart",
  "crn::cortex.lifecycle.trigger::event-type:soft_reboot": "Weicher Neustart",
};
